
/**
 * Subscription validation logic.
 * The code is a 12-digit number.
 * Checksum rule: Sum of first 10 digits modulo 100 must equal the last 2 digits.
 */

export function validateGoldCode(code: string): boolean {
  if (!/^\d{12}$/.test(code)) return false;
  
  const mainPart = code.substring(0, 10);
  const checkPart = parseInt(code.substring(10), 10);
  
  let sum = 0;
  for (let i = 0; i < mainPart.length; i++) {
    sum += parseInt(mainPart[i], 10);
  }
  
  // Custom simple checksum logic
  const calculatedCheck = (sum * 7) % 100;
  return calculatedCheck === checkPart;
}

export function generateWhatsAppLink(number: string, lang: 'fr' | 'en'): string {
  const message = lang === 'fr' 
    ? 'Bonjour, je souhaite activer mon plan GOLD Omen.' 
    : 'Hello, I would like to activate my Omen GOLD plan.';
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}